export function isSignatureValid(name, signature) {
  if (name.toLowerCase() === signature.toLowerCase()) {
    return true;
  }
  return false;
}
export function isAmountValid(payment, balance) {
  const minimumPayment = balance < 1850 ? 200 : 450;
  if (payment < balance && payment > minimumPayment) {
    return true;
  }
  return false;
}
export function isExpDateValid(expDate) {
  const split = expDate ? expDate.split('-') : '';
  const today = new Date();
  const dateToCompare = today.getFullYear() + today.getMonth() + 1;
  const inputDate = parseInt(split[0], 10) + parseInt(split[1], 10);
  if (inputDate >= dateToCompare) {
    return true;
  }
  return false;
}
export function isCardNumValid(num) {
  if (/^\d+$/.test(num)) {
    return true;
  }
  return false;
}
export function isCVCNumValid(num) {
  if (/^\d+$/.test(num)) {
    return true;
  }
  return false;
}
export function passwordValidator(control) {
  // 6 characters, uppercase letters, lowercase letters, special characters, numbers
  if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#$%^&*?])(?=.{6,})/.test(control.value)) {
    return null;
  } else {
    return { password: true };
  }
}
export function phoneNumberValidator(control) {
  const phoneNumberRegex = /^[a-zA-Z0-9\-+().\s]{10,15}$/;
  if (control.value && control.value.length > 0 && !phoneNumberRegex.test(control.value)) {
    return { phoneNumber: true };
  }
  return null;
}
export function readableResponseMessage(obj, defaultMessage) {
  let message = defaultMessage
    ? defaultMessage
    : "Whoops! We're having a problem processing your request.";
  if (obj.response && obj.response.data && obj.response.data.Message) {
    let messageObject = obj.response.data.Message.split(': ');
    message = messageObject.shift();
    message = messageObject.join();
  } else if (obj.message) {
    let messageObject = obj.message.split(': ');
    if (messageObject.length > 1) {
      message = messageObject.shift();
      message = messageObject.join();
    } else {
      message = messageObject[0];
    }
  } else if (obj.error_messages && Array.isArray(obj.error_messages)) {
    message = obj.error_messages.join(', ');
  } else if (obj.Message) {
    message = obj.Message;
  } else message = defaultMessage;
  return message;
}
export function scroller(id) {
  let offsetElement = document.createElement('span');
  offsetElement.setAttribute('id', id + '-offset');
  offsetElement.className = 'scroll-to-offset';
  let mainElement = document.querySelector(`#${id}`);
  mainElement.className += ' position-relative';
  mainElement.appendChild(offsetElement);
  document.querySelector(`#${id}-offset`).scrollIntoView({
    behavior: 'smooth',
  });
}
export function grabPrimaryName(tripName) {
  //initialization
  let primaryName = '';
  //scuba edge case,
  if (tripName.indexOf('SCUBA') > 0) {
    primaryName = 'SCUBA';
  } else {
    primaryName = tripName.split(' ').shift();
  }

  //edge case
  if (primaryName === 'Thailand:') {
    return 'Thailand 35+';
  }
  // edge case
  if (primaryName === 'WILD:') {
    return 'WILD: PNW';
  }
  if (primaryName === 'Southeast') {
    return 'Southeast Asia';
  }
  return primaryName;
}
